// Path: C:\gestion-copro\src\services\prospection.service.ts
// Session 189 : Service frontend CRM — génération mail + Gmail OAuth + envoi
// Session 190 : Ajout exchangeGmailCodeCrm (remplace handleGmailCallbackCrm onRequest)
// SÉPARÉ des services Gmail copropriété

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { TypeTemplateMail } from '../types/crm.types';

// ============================================
// TYPES
// ============================================

export interface ResultatMailProspection {
  objet: string;
  contenuTexte: string;
  contenuHtml: string;
}

// ============================================
// GÉNÉRATION MAIL VIA SENTINELLE
// ============================================

export const genererMailProspection = async (
  prospectId: string,
  template: TypeTemplateMail,
  instructionsLibres?: string
): Promise<ResultatMailProspection> => {
  const callable = httpsCallable<
    { prospectId: string; template: TypeTemplateMail; instructionsLibres?: string },
    { success: boolean; mail: ResultatMailProspection }
  >(functions, 'genererMailProspection');

  const result = await callable({
    prospectId,
    template,
    instructionsLibres: instructionsLibres || undefined,
  });

  if (!result.data.success || !result.data.mail) {
    throw new Error('La génération du mail a échoué.');
  }

  return result.data.mail;
};

// ============================================
// GMAIL OAUTH CRM
// ============================================

export const getGmailAuthUrlCrm = async (): Promise<string> => {
  const callable = httpsCallable<Record<string, never>, { authUrl: string }>(
    functions,
    'getGmailAuthUrlCrm'
  );
  const result = await callable({});
  return result.data.authUrl;
};

/**
 * Échange le code OAuth (reçu par GmailCrmCallbackPage) contre des tokens Gmail.
 * Stocke les tokens dans users/{uid}/private/gmailTokens via Cloud Function.
 */
export const exchangeGmailCodeCrm = async (
  code: string
): Promise<{ success: boolean; email?: string; error?: string }> => {
  const callable = httpsCallable<
    { code: string },
    { success: boolean; email?: string }
  >(functions, 'exchangeGmailCodeCrm');

  const result = await callable({ code });
  return result.data;
};

export const disconnectGmailCrm = async (): Promise<void> => {
  const callable = httpsCallable<Record<string, never>, { success: boolean }>(
    functions,
    'disconnectGmailCrm'
  );
  await callable({});
};

// ============================================
// ENVOI MAIL CRM
// ============================================

export const envoyerMailProspection = async (data: {
  to: string;
  subject: string;
  body: string;
  isHtml: boolean;
  prospectId?: string;
  prospectNom?: string;
}): Promise<{ messageId?: string; threadId?: string }> => {
  const callable = httpsCallable<
    typeof data,
    { success: boolean; messageId?: string; threadId?: string }
  >(functions, 'sendEmailCrm');

  const result = await callable(data);

  if (!result.data.success) {
    throw new Error("L'envoi du mail a échoué.");
  }

  return {
    messageId: result.data.messageId,
    threadId: result.data.threadId,
  };
};
